<template>
    <div>
        <div :class="{'show': toggleModal }" class="modal fade">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header border-bottom">
                        <h5 class="modal-title h4">{{$t('header.edit') + $t(`subMenu.salon_menu_treatment`)}}
                            <small class="m-0 text-muted">{{$t(`subMenu.salon_menu_treatment`)}} - "{{sTitle}}"</small>
                        </h5>
                        <button type="button" class="close" @click="closeModal">
                            <span aria-hidden="true"><i class="fal fa-times"></i></span>
                        </button>
                    </div>
                    <div class="modal-body edit-modal-body">
                        <ul class="nav nav-pills nav-justified" role="tablist">
                            <li v-for="progress in this.$i18n.messages[this.$i18n.locale].tab.treatmentProgressTab" :key="progress.id" class="nav-item">
                                <a :class="{'active': selectedTab == progress.id}" class="nav-link border-bottom-left-radius-0 border-bottom-right-radius-0" data-toggle="tab">{{progress.id}}. {{progress.text}}</a>
                            </li>
                        </ul>
                        <div class="tab-content">
                            <div :class="{'active': selectedTab == 1}" class="tab-pane">
                                <treatmentForm ref="treatmentForm" :isEdit="true" @returnTreatment="closeModal" @saveTreatmentInfo="saveTreatmentInfo"></treatmentForm>
                            </div>
                            <div :class="{'active': selectedTab == 2}" class="tab-pane">
                                <therapyItem ref="therapyItem" :treatmentID="treatmentID" @previous="previous" @saveTherapy="saveTherapy" @returnTreatment="closeModal"></therapyItem>
                            </div>
                            <div :class="{'active': selectedTab == 3}" class="tab-pane">
                                <treatmentTherapySummary ref="treatmentTherapySummary" @previous="previous" @submitTreatmentTherapy="submitTreatmentTherapy" @returnTreatment="closeModal"></treatmentTherapySummary>
                            </div>
                        </div>  
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import TreatmentForm from './Treatment_Form'
import TherapyItem from './Therapy_Item'
import TreatmentTherapySummary from './Treatment_Therapy_Summary'
import {handleSessionExpired} from './../../../../assets/js/dashboard/dashboard'
export default {
    name: 'treatmentTherapyForm',
    components:{
        TreatmentForm, TherapyItem, TreatmentTherapySummary
    },
    data(){
        return {
            toggleModal: false, selectedTab: 1, 
            sTitle: "", objTreatment: {}, therapyItem: [],
            submitTherapyItem: [], 
            treatmentID: 0, isSubmit: false
        }
    },
    methods:{
        closeModal(isError){
            if(this.isSubmit){
                if(!isError){
                    this.toggleModal = false
                    this.$refs.treatmentForm.resetForm()
                    this.$emit('returnTreatment')
                }
            }else{
                this.toggleModal = false
                this.$refs.treatmentForm.resetForm()
                this.$emit('returnTreatment')
            }
            this.$parent.$parent.$parent.isModalShow = false
            
        },
        editItem(item){
            this.selectedTab = 1
            this.treatmentID = item.TnTreatmentID
            this.sTitle = item.TnTreatmentName
            this.therapyItem = item.TnTherapy
            this.$refs.treatmentForm.editTreatment(item)
            this.toggleModal = true
        },
        saveTreatmentInfo(item){
            this.objTreatment = Object.assign({}, item)
            this.selectedTab = 2
            this.$refs.therapyItem.editTherapy(this.therapyItem)
        },
        saveTherapy(item){
            this.submitTherapyItem = JSON.parse(JSON.stringify(item))
            this.selectedTab = 3
            this.$refs.treatmentTherapySummary.setSummary(this.objTreatment, this.submitTherapyItem)
        },
        previous(step){
            this.selectedTab = step - 1
        },
        async submitTreatmentTherapy(){
            let $vm = this
            var treatmentFlag = await this.submitTreatment()
            console.log(treatmentFlag)
            
            if(treatmentFlag){
                var arrTherapyFlag = []
                for(var i=0; i<this.submitTherapyItem.length; i++){
                    var therapyFlag = await this.submitTherapy(this.submitTherapyItem[i])
                    arrTherapyFlag.push(therapyFlag)
                }
                if(arrTherapyFlag.indexOf(false) == -1){
                    var message = this.objTreatment.TnTreatmentName + "' " + this.$i18n.t('message.success.success', {'action': this.$i18n.t('message.success.action.update')})
                    this.$parent.$parent.$parent.setModal(this, false, true, message);
                }else{
                    this.$parent.$parent.$parent.setModal(this, true, true,  $vm.$i18n.t('message.error.system_error'));
                }
            }else{
                this.$parent.$parent.$parent.setModal(this, true, true,  $vm.$i18n.t('message.error.system_error'));
            }
            this.isSubmit = true
        },
        async submitTreatment(){
            let url = this.$api.MENU_TREATMENT + "/" + this.treatmentID + this.$api.UPDATE

            var data = this.objTreatment

            let $vm = this
            var flag = false;
            await $vm.$axios({
                method: 'post', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')},
                data: data,
            })
            .then((response) => {
                if(response.status == 200){
                    flag = true
                }
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();  
                }
            })
            return flag
        },
        async submitTherapy(data){
            console.log(data)
            var itemID = data.itemID
            let _url = this.$api.MENU_THERAPY
            let url = itemID != 0 ?  _url + "/" + itemID  + this.$api.UPDATE : _url

            let $vm = this
            var flag = false

            delete data.itemID;
            await $vm.$axios({
                method: 'post', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')},
                data: data,
            })
            .then((response) => {
                if(response.status == 200){
                    flag = true
                }
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();  
                }
            })
            return flag
        }
    }
}
</script>
<style scoped>
.show{
    display: block;
}
.edit-modal-body{
    max-height: 80vh;
    overflow-y: auto;
}

</style>